module.exports = __webpack_public_path__ + "media/images/tabler-light-a5f7285f4049214fc40b1a876ad966cf.svg";